import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { PostgrestError } from "@supabase/supabase-js"
import { toast } from "@/hooks/use-toast"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Handles Supabase errors and displays them in a toast
 * @param error PostgrestError or any other error
 * @param customMessage Optional custom message to display instead of the error message
 */
export function supabaseErrorToToast(error: PostgrestError | Error | unknown, customMessage?: string): void {
  console.error('Supabase error:', error);
  
  const title = 'Error';
  let description = customMessage || 'Ha ocurrido un error inesperado';
  
  if (error instanceof Error) {
    description = customMessage || error.message;
  } else if (typeof error === 'object' && error !== null && 'message' in error) {
    description = customMessage || (error as { message: string }).message;
  }
  
  // Handle authentication errors (401/403)
  if (typeof error === 'object' && error !== null && 'code' in error) {
    const errorCode = (error as { code: string }).code;
    if (errorCode === '401' || errorCode === '403' || errorCode === 'PGRST116' || errorCode === 'PGRST301') {
      // Redirect to login page
      window.location.href = '/login';
      return;
    }
  }
  
  toast({
    variant: "destructive",
    title,
    description,
  });
}
